import { beAsyncTaskGetTaskDetails } from 'Api/beAsyncTaskApi'
import {
  beAutomationApiCheckCanCreate,
  beAutomationApiCopyTrigger,
  beAutomationApiDelete,
  beAutomationApiSearchTasks,
  beAutomationApiSetTaskEnable,
  beAutomationApiSimulate
} from 'Api/beAutomationApi'
import { beListApiGetAllTags } from 'Api/beListApi'
import { beMessGetMessageMinimumDetails } from 'Api/beMessApi'
import { beSmsMessageGetSMSDetails } from 'Api/beSmsMessageApi'
import { beSMSSendGetCountOfSMSSent } from 'Api/beSMSSendApi'
import { statisticsGetMessageTotalCounters } from 'Api/statisticsApi'
import { STORE_KEY_ID_LIST } from 'Constants/'
import { storeGet } from 'Helpers/localStorage'

export async function checkCanCreate() {
  const result = await beAutomationApiCheckCanCreate()
  return result
}

export async function getTasksList(params, bodyParams) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const result = beAutomationApiSearchTasks(idList, params, bodyParams)
  return result
}

export async function getMessageMinimumDetails(idMessage) {
  const result = beMessGetMessageMinimumDetails(idMessage)
  return result
}

export async function getMessageTotalCounters(idList, idMessage, types) {
  const result = statisticsGetMessageTotalCounters(idList, idMessage, types)
  return result
}

export async function getCountOfSMSSent(idMessage) {
  const result = beSMSSendGetCountOfSMSSent(idMessage)
  return result
}

export async function getSmsMessageGetSMSDetails(idMessage) {
  const result = beSmsMessageGetSMSDetails(idMessage)
  return result
}

export async function setTaskEnable(idTask, params) {
  const result = beAutomationApiSetTaskEnable(idTask, params)
  return result
}

export async function copyTrigger(idTask) {
  const result = beAutomationApiCopyTrigger(idTask)
  return result
}

export async function simulate(idTask) {
  const result = beAutomationApiSimulate(idTask)
  return result
}

export async function deleteTask(idTask) {
  const result = beAutomationApiDelete(idTask)
  return result
}

export async function simulateAsync(idTask) {
  const result = beAsyncTaskGetTaskDetails(idTask)
  return result
}

export async function getTags() {
  const idList = parseInt(storeGet(STORE_KEY_ID_LIST))

  const { Items } = await beListApiGetAllTags(idList, true, false)

  return Items.map((t) => ({
    label: t.Name,
    value: t.Id
  }))
}
